export { default, Icon } from '../components/icon-new';
export type { NewIconProps, NewCoreIconProps } from '../types';
